import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { selectToken, selectAccountRole } from '../../../features/auth/ducks';
import { DocumentsList } from '../../../common/components/data-display';
import { MajakIcon } from '../../../common/components';
import { accountRoles, contractType } from '../../../common/enums';

const DocumentsPanel = ({ t, contracts, toggleDocuments, token, accountRole, title }) => {

  if (accountRole !== accountRoles.ADMINISTRATOR || accountRole !== accountRoles.OPERATOR){
    contracts = contracts.filter(contract => contract.type !== contractType.ALLOCATION_TRANSFER)
  }
  return (
  <div className="documents-panel-wrapper">
    <div className="panel-header">
      <h3>{title ? title : t('Dokumenty')}</h3>
      <MajakIcon onClick={toggleDocuments} type="zavriet" />
    </div>
    <DocumentsList documents={contracts} token={token} accountRole={accountRole} />
  </div>
  )
};

DocumentsPanel.propTypes = {
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
  contracts: PropTypes.array.isRequired,
  toggleDocuments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  token: selectToken(state),
  accountRole: selectAccountRole(state),
});

export default connect(mapStateToProps)(translate()(DocumentsPanel));



// WEBPACK FOOTER //
// ./src/features/dashboard/components/DocumentsPanel.js